import { render, staticRenderFns } from "./iosGame.vue?vue&type=template&id=718ce608&scoped=true&"
import script from "./iosGame.vue?vue&type=script&lang=js&"
export * from "./iosGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718ce608",
  null
  
)

export default component.exports